import { Injectable, Inject } from "@angular/core";
import { HttpService } from "./http.service";
import { Router } from "@angular/router";
import { ENV } from "../environments/environment-variables.token";
import { SessionStorageService } from "angular-web-storage";
import { UtilsProvider } from "src/commons/utils";

@Injectable({
	providedIn: "root"
})
export class AuthService {
	constructor(
		private http: HttpService,
		private router: Router,
		public session: SessionStorageService,
		private utils: UtilsProvider,
		@Inject(ENV) public ENV: any
	) { }

	login(data: any): any {
		return new Promise((resolve, reject) => {
			this.http.post("api/users/users/login", false, data).then(res => {
				this.setToken(res.token).then(() => {
					resolve(res.token);
				});
			}).catch(err => {
				console.log("erroorrre", err);
				return this.utils.toast({
					/* message: err.error.message, */
					message: "Email ou senha inválidos",
					duration: 10000,
					action: "Ok"
				});
			});
		});
	}

	register(data: any): any {
		return new Promise((resolve, reject) => {
			this.http.post("api/users/users/createuser", false, data).then(res => {
				this.setToken(res.token).then(() => {
					resolve(true);
				});
			}).catch(err => {
				console.log("erroorrre", err);
				//reject(err)
				return this.utils.toast({
					/* message: err.error.message, */
					message: "Este usuário já está cadastrado, tente novamente com outro email.",
					duration: 10000,
					action: "Ok"
				});
			});
		});
	}

	forgotPassword(data: any): any {
		return new Promise((resolve, reject) => {
			this.http.post("api/users/users/forgotPassWord", false, data).then(() => {
				console.log("E-mail enviado!");
				this.utils.toast({
					message:"Um email com uma senha provisória foi enviado em sua caixa de entrada",
					duration: 10000,
					action: "Ok"
				})
				resolve(true);
			}).catch(err => reject(err));
		});
	}

	sendContactEmail(data: any): any {
		return new Promise((resolve, reject) => {
			this.http.post("api/users/users/contactEmail", false, data).then(() => {
				console.log("E-mail enviado!");
				this.utils.toast({
					message:"Sua mensagem foi enviada e em breve retornaremos o contato.",
					duration: 10000,
					action: "Ok"
				})
				resolve(true);
			}).catch(err => reject(err));
		});
	}

	logout() {
		return new Promise((resolve, reject) => {
			// this.setToken("").then(() => {
			// 	resolve(true);
			// });
			// sessionStorage.clear();
			localStorage.clear();
			resolve(true);
		}).catch(err => console.log("Error trying to log you out: ", err));
	}

	setToken(token: string): any {
		return new Promise((resolve, reject) => {
			this.http.setToken(token).then(r => {
				this.me().then(() => {
					resolve(true);
				});
			});
		}).catch(err => console.log("Error trying to set token: ", err));
	}

	me() {
		return new Promise((resolve, reject) => {
			this.http.get("api/users/users/me", true).then((auth: any) => {
				this.ENV.USER = auth;
				// this.session.set("userInfo", auth, 2, "h");
				const userInfo = JSON.stringify(auth);
				localStorage.setItem("user", userInfo);
				resolve(true);
			})
			.catch(err => {
				localStorage.clear();
				// localStorage.removeItem('user');
				this.router.navigate(["/login"]);
				reject(err);
			});
		});
	}
}


